import { Text } from '../../model/components/Text';
import { PathContextProvider } from '../../PathContext';
import { ColorInput } from './ColorInput';
import { TranslationTableInput } from './TranslationTableInput';
import { hexToUnityColor, UnityColor } from '@lifeserver/shared';

const ALLOWED_COLORS: UnityColor[] = (
    [
        '#000000',
        '#FFFFFF',
        '#23497B',
        '#973911',
        '#06463F',
        '#414881',
        '#823312',
    ] as const
).map(hexToUnityColor);

export interface TextInputProps {
    value: Text;
    onChange?: (value: Text) => void;
}
export const TextInput = ({ value, onChange }: TextInputProps) => {
    const onFieldChange = <Field extends keyof Text>(
        field: Field,
        fieldValue: Text[Field],
    ) => {
        onChange?.({
            ...value,
            [field]: fieldValue,
        });
    };

    return (
        <>
            <fieldset>
                <legend>Text</legend>
                <PathContextProvider segment="text">
                    <TranslationTableInput
                        value={value.text}
                        onChange={(value) => onFieldChange('text', value)}
                    />
                </PathContextProvider>
            </fieldset>
            <fieldset>
                <legend>Text Color</legend>
                <ColorInput
                    value={value.textColor}
                    allowedColors={ALLOWED_COLORS}
                    onChange={(value) => onFieldChange('textColor', value)}
                />
            </fieldset>
        </>
    );
};
